import * as React from 'react';
type IconBackProps = React.SVGProps<SVGSVGElement>;

export const IconBack: React.FC<IconBackProps> = (props) => (
	<svg
		width={18}
		height={16}
		viewBox="0 0 18 16"
		fill="white"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path d="M0.367188 8.8833C-0.121094 8.39502 -0.121094 7.60205 0.367188 7.11377L6.61719 0.86377C7.10547 0.375488 7.89844 0.375488 8.38672 0.86377C8.875 1.35205 8.875 2.14502 8.38672 2.6333L4.26562 6.75049H16.25C16.9414 6.75049 17.5 7.30908 17.5 8.00049C17.5 8.69189 16.9414 9.25049 16.25 9.25049H4.26953L8.38281 13.3677C8.87109 13.856 8.87109 14.6489 8.38281 15.1372C7.89453 15.6255 7.10156 15.6255 6.61328 15.1372L0.363281 8.88721L0.367188 8.8833Z" />
	</svg>
);
export default IconBack;
